import { IconSend } from '@tabler/icons-react-native';
import { useTranslation } from 'react-i18next';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTheme } from '@shopify/restyle';
import type { Theme } from 'app/shopify';
// Feature-specific blue from Figma; no matching semantic runtime token exists.
export const GUARDIAN_BLUE = '#253E8A';
export function GuardianBadge() {
  const { t } = useTranslation('guardian');
  const theme = useTheme<Theme>();
  return (
    <Row
      alignSelf="flex-start"
      alignItems="center"
      gap="spacing.general.x1"
      style={{ backgroundColor: GUARDIAN_BLUE, borderRadius: 100, paddingHorizontal: 12, paddingVertical: 5 }}
    >
      <IconSend size={16} color={theme.colors.white} />
      <Text color="white" fontSize={12} fontWeight="600">
        {t('badge')}
      </Text>
    </Row>
  );
}
